import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

// ─── Icon helpers ─────────────────────────────────────────────────────────────
const Icon = ({ d, className = "w-5 h-5" }: { d: string; className?: string }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d={d} />
    </svg>
);

const ICONS: Record<string, string> = {
    dashboard: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
    calendar: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
    store: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z",
    analytics: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z",
    products: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4",
    categories: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z",
    serials: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2",
    restock: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15",
    invoices: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z",
    orders: "M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z",
    returns: "M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6",
    creditnotes: "M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z",
    customers: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z",
    purchases: "M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8l1 12a2 2 0 002 2h8a2 2 0 002-2l1-12",
    vendors: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4",
    units: "M4 6h16M4 10h16M4 14h16M4 18h16",
    finance: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1",
    insurance: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z",
    rto: "M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z",
    exchange: "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4",
    logistics: "M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0",
    delivery_route: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z",
    delivery_sub: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
    delivery_assign: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2",
    accounting: "M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z",
    ledger: "M4 6h16M4 10h16M4 14h8m-8 4h8",
    vouchers: "M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z",
    reports: "M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z",
    companies: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4",
    modules: "M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z",
    roles: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z",
    staff: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z",
    profile: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
    settings: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z",
    logout: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1",
    collapse: "M11 19l-7-7 7-7m8 14l-7-7 7-7",
    expand: "M13 5l7 7-7 7M5 5l7 7-7 7",
    plus: "M12 4v16m8-8H4",
};

interface NavSection {
    id: number;
    title: string;
    iconKey: string;
    hide?: boolean;
    links: { path: string; label: string; iconKey: string; hide?: boolean }[];
}

// ─── Main SidebarContent ─────────────────────────────────────────────────────
const SidebarContent = ({
    onClose,
    isActive,
    collapsed,
    onToggleCollapse,
}: {
    onClose?: () => void;
    isActive: (path: string) => boolean;
    collapsed?: boolean;
    onToggleCollapse?: () => void;
}) => {
    const [openSection, setOpenSection] = useState<number | null>(null);
    const [searchQuery, setSearchQuery] = useState("");
    const isStaff = (window as any).CURRENT_FIRM?.role_slug === "staff";

    const sections: NavSection[] = [
        {
            id: 1, title: "Dashboard", iconKey: "dashboard",
            links: [
                { path: "/", label: "Main Dashboard", iconKey: "analytics" },
                { path: "/calendar", label: "Calendar", iconKey: "calendar" },
                { path: "/store", label: "Store Config", iconKey: "store" },
                { path: "/store/analytics", label: "Analytics", iconKey: "reports" },
            ],
        },
        {
            id: 2, title: "Inventory", iconKey: "products",
            links: [
                { path: "/products", label: "Products", iconKey: "products" },
                { path: "/categories", label: "Categories", iconKey: "categories" },
                { path: "/product_units", label: "Serial Numbers", iconKey: "serials" },
                { path: "/restocks", label: "Restock History", iconKey: "restock" },
            ],
        },
        {
            id: 3, title: "Sales & CRM", iconKey: "orders",
            links: [
                { path: "/invoices", label: "Invoices", iconKey: "invoices" },
                { path: "/orders", label: "Orders", iconKey: "orders" },
                { path: "/returns", label: "Returns", iconKey: "returns" },
                { path: "/credit-notes", label: "Credit Notes", iconKey: "creditnotes" },
                { path: "/customers", label: "Customers", iconKey: "customers" },
            ],
        },
        {
            id: 4, title: "Purchasing", iconKey: "purchases",
            links: [
                { path: "/purchases", label: "Purchases", iconKey: "purchases" },
                { path: "/vendors", label: "Vendors", iconKey: "vendors" },
            ],
        },
        {
            id: 5, title: "Masters", iconKey: "units", hide: isStaff,
            links: [
                { path: "/units", label: "Product Units", iconKey: "units" },
                { path: "/finance_companies", label: "Finance Houses", iconKey: "finance" },
                { path: "/insurance_companies", label: "Insurers", iconKey: "insurance" },
                { path: "/rto_agents", label: "RTO Agents", iconKey: "rto" },
                { path: "/exchange_dealers", label: "Exchange Dealers", iconKey: "exchange" },
                { path: "/locations", label: "Logistics Hubs", iconKey: "logistics" },
            ],
        },
        {
            id: 6, title: "Accounting", iconKey: "accounting",
            links: [
                { path: "/accounting", label: "Accounts Hub", iconKey: "analytics" },
                { path: "/accounting/account-groups", label: "Account Groups", iconKey: "categories" },
                { path: "/accounting/account-heads", label: "Account Heads", iconKey: "finance" },
                { path: "/accounting/bank-accounts", label: "Bank Accounts", iconKey: "accounting" },
                { path: "/accounting/vouchers", label: "Vouchers", iconKey: "vouchers" },
                { path: "/accounting/ledger", label: "Ledger", iconKey: "ledger" },
                { path: "/accounting/reports", label: "Financial Reports", iconKey: "reports" },
            ],
        },
        {
            id: 7, title: "Settings", iconKey: "settings",
            links: [
                { path: "/firms", label: "Companies", iconKey: "companies" },
                { path: "/settings/modules", label: "Modules", iconKey: "modules" },
                { path: "/settings/roles", label: "Roles & Permissions", iconKey: "roles" },
                { path: "/staff", label: "Staff Management", iconKey: "staff" },
                { path: "/settings/product-fields", label: "Product Fields", iconKey: "settings" },
            ],
        },
        {
            id: 8, title: "Subscriptions & Delivery", iconKey: "logistics",
            // hide: (window as any).CURRENT_FIRM?.industry !== 'dairy',
            links: [
                { path: "/delivery/today", label: "Today Deliveries", iconKey: "analytics" },
                { path: "/delivery/routes", label: "Delivery Routes", iconKey: "delivery_route", hide: isStaff },
                { path: "/delivery/subscriptions", label: "Subscriptions", iconKey: "delivery_sub", hide: isStaff },
                { path: "/delivery/assignments", label: "Assignments", iconKey: "delivery_assign" },
                { path: "/delivery/billing", label: "Monthly Billing", iconKey: "invoices", hide: isStaff },
            ],
        },
    ];

    const quickActions = [
        { path: "/products/manage", label: "Products", iconKey: "products", bg: "bg-indigo-50 hover:bg-indigo-100", text: "text-indigo-600" },
        { path: "/restocks/new", label: "Restock", iconKey: "restock", bg: "bg-emerald-50 hover:bg-emerald-100", text: "text-emerald-600" },
        { path: "/orders/manage", label: "Quick Order", iconKey: "orders", bg: "bg-indigo-50 hover:bg-indigo-100", text: "text-indigo-600" },
        { path: "/orders/new", label: "Order", iconKey: "orders", bg: "bg-amber-50 hover:bg-amber-100", text: "text-amber-600" },
        { path: "/invoices/new", label: "Invoice", iconKey: "invoices", bg: "bg-rose-50 hover:bg-rose-100", text: "text-rose-600" },
        { path: "/delivery/assignments", label: "Assign", iconKey: "delivery_assign", bg: "bg-sky-50 hover:bg-sky-100", text: "text-sky-600" },
    ];

    const filtered = sections
        .filter((s) => !s.hide)
        .filter((s) => {
            if (!searchQuery) return true;
            const q = searchQuery.toLowerCase();
            return (
                s.title.toLowerCase().includes(q) ||
                s.links.some((l) => l.label.toLowerCase().includes(q))
            );
        })
        .map((s) => ({
            ...s,
            links: s.links.filter(
                (l) =>
                    !searchQuery ||
                    s.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    l.label.toLowerCase().includes(searchQuery.toLowerCase())
            ).filter(l => !l.hide),
        }));

    useEffect(() => {
        if (searchQuery.length > 1) {
            const first = filtered.find((s) => s.links.length > 0);
            if (first) setOpenSection(first.id);
        }
    }, [searchQuery]);

    const handleNavClick = () => onClose?.();

    if (collapsed) {
        // Icon-only mode
        return (
            <div className="flex flex-col h-full pt-4 pb-6 overflow-y-auto">
                {/* Logo area */}
                <div className="flex justify-center mb-4 px-3">
                    <div className="w-10 h-10 bg-indigo-600 rounded-xl flex items-center justify-center text-white font-black text-lg select-none">
                        I
                    </div>
                </div>

                {/* Expand button */}
                <button
                    onClick={onToggleCollapse}
                    title="Expand sidebar"
                    className="mx-auto mb-6 w-9 h-9 flex items-center justify-center rounded-xl bg-slate-100 hover:bg-indigo-50 hover:text-indigo-600 text-slate-400 transition-colors"
                >
                    <Icon d={ICONS.expand} className="w-4 h-4" />
                </button>

                {/* Section icons */}
                <div className="flex flex-col items-center gap-1 px-2 flex-1">
                    {sections.filter((s) => !s.hide).map((section) => {
                        const sectionActive = section.links.some((l) => isActive(l.path));
                        return (
                            <div key={section.id} className="relative group">
                                <button
                                    onClick={() => setOpenSection(openSection === section.id ? null : section.id)}
                                    className={`w-10 h-10 flex items-center justify-center rounded-xl transition-colors ${sectionActive
                                        ? "bg-indigo-600 text-white"
                                        : "text-slate-500 hover:bg-indigo-50 hover:text-indigo-600"
                                        }`}
                                    title={section.title}
                                >
                                    <Icon d={ICONS[section.iconKey]} className="w-5 h-5" />
                                </button>
                                {/* Tooltip */}
                                <div className="pointer-events-none absolute left-full ml-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-slate-900 text-white text-xs font-semibold px-2 py-1 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity z-50">
                                    {section.title}
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* Bottom icons */}
                <div className="flex flex-col items-center gap-1 px-2 pt-4 border-t border-slate-100">
                    <Link to="/profile" onClick={handleNavClick} title="Profile"
                        className={`w-10 h-10 flex items-center justify-center rounded-xl transition-colors ${isActive("/profile") ? "bg-indigo-600 text-white" : "text-slate-500 hover:bg-indigo-50 hover:text-indigo-600"}`}>
                        <Icon d={ICONS.profile} className="w-5 h-5" />
                    </Link>
                    <button
                        onClick={() => { (window as any).LOGOUT_TRIGGER?.(); onClose?.(); }}
                        title="Log out"
                        className="w-10 h-10 flex items-center justify-center rounded-xl text-rose-400 hover:bg-rose-50 hover:text-rose-600 transition-colors"
                    >
                        <Icon d={ICONS.logout} className="w-5 h-5" />
                    </button>
                </div>
            </div>
        );
    }

    // ── Full sidebar ──────────────────────────────────────────────────────────
    return (
        <div className="flex flex-col h-full overflow-y-auto custom-scrollbar">
            {/* Header */}
            <div className="flex items-center justify-between px-4 py-4 border-b border-slate-100">
                <div className="flex items-center gap-3">
                    <div className="w-9 h-9 bg-indigo-600 rounded-xl flex items-center justify-center text-white font-black text-base select-none">
                        I
                    </div>
                    <div>
                        <div className="font-black text-slate-800 text-sm tracking-tight leading-none">Inventory</div>
                        <div className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Management OS</div>
                    </div>
                </div>
                {onToggleCollapse && (
                    <button
                        onClick={onToggleCollapse}
                        title="Collapse sidebar"
                        className="p-1.5 rounded-lg text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors"
                    >
                        <Icon d={ICONS.collapse} className="w-4 h-4" />
                    </button>
                )}
            </div>

            {/* Quick Actions */}
            <div className="p-3 grid grid-cols-4 gap-1.5 border-b border-slate-100">
                {quickActions.map((a) => (
                    <Link
                        key={a.path}
                        to={a.path}
                        onClick={handleNavClick}
                        className={`flex flex-col items-center justify-center p-2 rounded-xl ${a.bg} transition-colors`}
                    >
                        <span className={`${a.text} mb-0.5`}>
                            <Icon d={ICONS[a.iconKey]} className="w-4 h-4" />
                        </span>
                        <span className={`text-[9px] font-black uppercase tracking-tight ${a.text}`}>{a.label}</span>
                    </Link>
                ))}
            </div>

            {/* Search */}
            <div className="px-3 py-3 border-b border-slate-100">
                <div className="relative">
                    <Icon d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" className="w-4 h-4 absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
                    <input
                        type="text"
                        placeholder="Quick find..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="w-full pl-8 pr-3 py-2 text-xs bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:border-indigo-400 focus:ring-1 focus:ring-indigo-200 transition-all"
                    />
                </div>
            </div>

            {/* Navigation */}
            <nav className="flex-1 px-2 py-3 space-y-0.5">
                {filtered.map((section) => {
                    const isOpen = openSection === section.id;
                    const sectionActive = section.links.some((l) => isActive(l.path));

                    return (
                        <div key={section.id}>
                            <button
                                onClick={() => setOpenSection(isOpen ? null : section.id)}
                                className={`w-full flex items-center justify-between gap-2 px-3 py-2.5 rounded-xl text-sm font-bold transition-all duration-200 group ${sectionActive && !isOpen
                                    ? "bg-indigo-50 text-indigo-700"
                                    : "text-slate-600 hover:bg-slate-100 hover:text-slate-800"
                                    }`}
                            >
                                <span className="flex items-center gap-2.5">
                                    <span className={`flex-shrink-0 transition-colors ${sectionActive ? "text-indigo-600" : "text-slate-400 group-hover:text-slate-600"}`}>
                                        <Icon d={ICONS[section.iconKey]} className="w-4.5 h-4.5" />
                                    </span>
                                    <span className="text-xs uppercase tracking-wider">{section.title}</span>
                                </span>
                                <svg
                                    className={`w-3.5 h-3.5 flex-shrink-0 text-slate-300 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
                                    fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" />
                                </svg>
                            </button>

                            {isOpen && (
                                <div className="mt-0.5 ml-3 pl-3 border-l-2 border-indigo-100 space-y-0.5 pb-1">
                                    {section.links.map((link) => {
                                        const active = isActive(link.path);
                                        return (
                                            <Link
                                                key={link.path}
                                                to={link.path}
                                                onClick={handleNavClick}
                                                className={`flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-xs font-semibold transition-all duration-150 ${active
                                                    ? "bg-indigo-600 text-white shadow-sm shadow-indigo-200"
                                                    : "text-slate-600 hover:bg-slate-100 hover:text-slate-800"
                                                    }`}
                                            >
                                                <span className={`flex-shrink-0 ${active ? "text-white" : "text-slate-400"}`}>
                                                    <Icon d={ICONS[link.iconKey]} className="w-3.5 h-3.5" />
                                                </span>
                                                {link.label}
                                            </Link>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    );
                })}
            </nav>

            {/* Footer */}
            <div className="px-2 py-3 border-t border-slate-100 space-y-0.5">
                <Link
                    to="/profile"
                    onClick={handleNavClick}
                    className={`flex items-center gap-2.5 px-3 py-2 rounded-xl text-xs font-semibold transition-all ${isActive("/profile") ? "bg-indigo-600 text-white" : "text-slate-600 hover:bg-slate-100"}`}
                >
                    <Icon d={ICONS.profile} className="w-4 h-4" />
                    Profile
                </Link>
                <Link
                    to="/settings"
                    onClick={handleNavClick}
                    className={`flex items-center gap-2.5 px-3 py-2 rounded-xl text-xs font-semibold transition-all ${isActive("/settings") ? "bg-indigo-600 text-white" : "text-slate-600 hover:bg-slate-100"}`}
                >
                    <Icon d={ICONS.settings} className="w-4 h-4" />
                    Core Settings
                </Link>
                <button
                    onClick={() => { (window as any).LOGOUT_TRIGGER?.(); onClose?.(); }}
                    className="w-full flex items-center gap-2.5 px-3 py-2 rounded-xl text-xs font-semibold text-rose-500 hover:bg-rose-50 hover:text-rose-700 transition-all"
                >
                    <Icon d={ICONS.logout} className="w-4 h-4" />
                    Sign Out
                </button>
            </div>

            {/* Cloud sync indicator */}
            <div className="mx-3 mb-4 p-3 bg-indigo-600 rounded-xl text-white">
                <div className="flex items-center gap-2 mb-1">
                    <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse"></span>
                    <span className="text-[11px] font-bold">Cloud Sync Active</span>
                </div>
                <p className="text-[10px] text-white/70 leading-relaxed">Transactions backed up to Bangalore servers.</p>
            </div>
        </div>
    );
};

// ─── Mobile burger + desktop persistent shell ─────────────────────────────────
export function SidebarWithBurgerMenu() {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [collapsed, setCollapsed] = useState(() => localStorage.getItem("sidebarCollapsed") === "true");
    const location = useLocation();

    const isActive = (path: string) =>
        location.pathname === path || (path !== "/" && location.pathname.startsWith(path + "/"));

    const closeDrawer = () => setIsDrawerOpen(false);

    const toggleCollapse = () => {
        const next = !collapsed;
        setCollapsed(next);
        localStorage.setItem("sidebarCollapsed", String(next));
    };

    return (
        <>
            {/* Mobile toggle button */}
            <button
                onClick={() => setIsDrawerOpen(true)}
                className="lg:hidden fixed top-3 left-4 z-[60] p-2 bg-white border border-slate-200 shadow-sm rounded-xl text-indigo-600 hover:bg-indigo-50 transition-colors"
                aria-label="Open navigation"
            >
                <Icon d="M4 6h16M4 12h16M4 18h16" className="w-5 h-5" />
            </button>

            {/* Mobile drawer overlay */}
            {isDrawerOpen && (
                <div
                    className="fixed inset-0 bg-black/30 backdrop-blur-sm z-[70] lg:hidden"
                    onClick={closeDrawer}
                />
            )}

            {/* Mobile drawer */}
            <aside
                className={`fixed top-0 left-0 h-full w-72 bg-white z-[80] shadow-2xl transition-transform duration-300 lg:hidden ${isDrawerOpen ? "translate-x-0" : "-translate-x-full"}`}
            >
                <div className="absolute top-3 right-3">
                    <button onClick={closeDrawer} className="p-1.5 rounded-lg text-slate-400 hover:bg-slate-100 transition-colors" aria-label="Close">
                        <Icon d="M6 18L18 6M6 6l12 12" className="w-5 h-5" />
                    </button>
                </div>
                <SidebarContent onClose={closeDrawer} isActive={isActive} />
            </aside>

            {/* Desktop persistent sidebar */}
            <aside
                className={`hidden lg:flex flex-col h-screen bg-white border-r border-slate-200 sticky top-0 shrink-0 transition-all duration-300 ease-in-out overflow-hidden ${collapsed ? "w-[64px]" : "w-64"}`}
            >
                <SidebarContent
                    isActive={isActive}
                    collapsed={collapsed}
                    onToggleCollapse={toggleCollapse}
                />
            </aside>
        </>
    );
}

export default SidebarWithBurgerMenu;
